import { useEffect, useState } from "react";
import { Row, Col, Progress } from "antd";

import MotivationalQuote from '../Utils/MotivationalQuote';
import ActionButton from './ActionButton';
// import useUserLocation from '../../hooks/useUserLocation';
import useTelegramUser from '../../hooks/useTelegramUser';
// import useUser from '../../hooks/useUser';
import { useUser } from  '../../hooks/UserProvider'
import LocationInstruction from './LocationInstruction'

const Home = () => {
  const { userData, location, error } = useUser();
  // const { location, error } = useUserLocation();
  const chatId = useTelegramUser();
  const [lastEvent, setLastEvent] = useState(null);

  useEffect(() => {
    if (userData?.last_event) {
      setLastEvent(userData.last_event);
    }
  }, [userData]);

  const determineEventType = () => {
    if (lastEvent === "clock_in") return "clock_out";
    return "clock_in"; // по умолчанию
  };

  const eventType = determineEventType();

  
  if(error){
    return <LocationInstruction/>
  }

  // Пока данные не загружены — показываем "Загрузка"
  if (!userData || !chatId) {
    return <p>Загрузка...</p>;
  }

  // Безопасный разбор расписания
  const [from, to] = userData.schedule?.split(',') || ['00:00', '00:00'];

  const toMinutes = (timeStr) => {
    const [h, m] = timeStr.split(':').map(Number);
    return h * 60 + m;
  };

  const totalScheduleMinutes = toMinutes(to) - toMinutes(from);
    const totalScheduleSeconds = totalScheduleMinutes * 60;

    const totalWorkedSeconds = userData.total_worked_today || 0;
    const percent = Math.min((totalWorkedSeconds / totalScheduleSeconds) * 100, 100);

    const workedH = Math.floor(totalWorkedSeconds / 3600);
    const workedM = Math.floor((totalWorkedSeconds % 3600) / 60);

    const plannedH = Math.floor(totalScheduleMinutes / 60);
    const plannedM = totalScheduleMinutes % 60;

    // правильная обработка переработки
    let remainingMinutes = totalScheduleMinutes - (totalWorkedSeconds / 60);
    if (remainingMinutes < 0) remainingMinutes = 0; // 🔥 обнуляем, если переработал

    const remainingH = Math.floor(remainingMinutes / 60);
    const remainingM = Math.floor(remainingMinutes % 60);


  console.log(userData)
  return (
    <div className="home">
      <Row>
        <Col span={24} className="employee-status">
          <div className="section-title">
            <p>Progress:</p>
          </div>
          <div className="progress">
            <div className="progress-timing">
              <p className="title">Working Time</p>
              <p className="time">
                <span>{workedH}h {workedM}m</span> / {plannedH}h {plannedM}m
              </p>
              <Progress
                percent={Math.round(percent)}
                status="active"
                className="progress-bar"
                strokeColor={{ from: "#d3a188", to: "#ff6f00" }}
              />
                {remainingMinutes > 0 ? (
                <p className="remaining-time">Remaining: {remainingH}h {remainingM}m</p>
                ) : (
                <p className="remaining-time">Extra Time: {Math.floor((totalWorkedSeconds - totalScheduleSeconds) / 3600)}h {Math.floor(((totalWorkedSeconds - totalScheduleSeconds) % 3600) / 60)}m</p>
                )}
            </div>

            <div className="info-blocks">
              <div className="item status">
                <div className={`sub-item ${eventType === "clock_out" ? "in" : "out"}`}>
                  <p>{eventType === "clock_out" ? "At work" : "Out of work"}</p>
                </div>
                <h6>Status</h6>
              </div>

              <div className="item schedule">
                <div className="sub-item">
                  <p>From: {from}</p>
                  <p>To: {to}</p>
                </div>
                <h6>Your Schedule</h6>
              </div>

              <div className="item location">
                <div className="sub-item">
                  <p>{userData.location !== "" ? userData.location : "You are not in the work area." }</p>
                </div>
                <h6>You are in</h6>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <div className="motivation-block">
            <MotivationalQuote />
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={24} className="action-btn">
          <ActionButton
            chatId={chatId}
            location={location}
            userData={userData}
            setLastEvent={setLastEvent}
            lastEvent={lastEvent}
            eventType={eventType}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Home;
